export const CURRENCY_TYPES = ` 
query currencyTypes(
    $filter: FilterCurrencyTypeInput!
    $orderBy: CurrencyTypeOrderInput
    $skip: Int
    $take: Int
  ) {
    currencyTypes(filter: $filter, orderBy: $orderBy, skip: $skip, take: $take) {
      __typename
      ... on CurrencyType {
        id
        code
        name
        description
        active
        its,
        uts,
        dts
        currency_type_identification_word {
          id
          currency_type_id
          identification_word
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
  `;